import { useTranslation } from "react-i18next";

export default function TestimonialSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 mb-3">
            <span className="w-2.5 h-2.5 rounded-full bg-primary-500"></span>
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-primary-600">
              {t("testimonials.tag")}
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-[1.15]">
            {t("testimonials.title_line1")}
            <br />
            {t("testimonials.title_line2")}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            {t("testimonials.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          <div className="bg-background-50 rounded-2xl p-6 md:p-7 flex flex-col gap-4">
            <div className="flex gap-1">
              {[...Array(5)].map((_, starI) => (
                <i key={starI} className="ri-star-fill text-sm text-primary-500"></i>
              ))}
            </div>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed flex-1">
              &ldquo;A planilha Hoobuy mudou completamente minha experiência de compra. Encontrei tênis que procurava há meses em menos de 5 minutos. Simplesmente incrível.&rdquo;
            </p>
            <div className="flex items-center gap-3 pt-2 border-t border-background-200/70">
              <div className="w-10 h-10 rounded-full overflow-hidden bg-secondary-100 flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Young%20Brazilian%20man%20with%20warm%20smile%20casual%20beige%20linen%20shirt%20soft%20natural%20window%20light%20clean%20cream%20background%20relaxed%20friendly%20portrait%20professional%20headshot%20style%20warm%20earth%20tones&width=80&height=80&seq=avatar-lucas-v2&orientation=squarish"
                  alt="Lucas Oliveira"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-950 leading-tight">Lucas Oliveira</p>
                <p className="text-xs text-foreground-500 leading-tight">São Paulo, Brasil</p>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-2xl p-6 md:p-7 flex flex-col gap-4">
            <div className="flex gap-1">
              {[...Array(5)].map((_, starI) => (
                <i key={starI} className="ri-star-fill text-sm text-primary-500"></i>
              ))}
            </div>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed flex-1">
              &ldquo;Finalmente uma planilha em português! Os links são sempre atualizados e a qualidade dos produtos é excelente. Recomendo para todos os meus amigos.&rdquo;
            </p>
            <div className="flex items-center gap-3 pt-2 border-t border-background-200/70">
              <div className="w-10 h-10 rounded-full overflow-hidden bg-secondary-100 flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Young%20Portuguese%20woman%20with%20gentle%20smile%20cream%20white%20blouse%20soft%20diffused%20natural%20light%20clean%20warm%20beige%20background%20relaxed%20elegant%20portrait%20professional%20headshot%20style%20warm%20ivory%20tones&width=80&height=80&seq=avatar-marina-v2&orientation=squarish"
                  alt="Marina Costa"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-950 leading-tight">Marina Costa</p>
                <p className="text-xs text-foreground-500 leading-tight">Lisboa, Portugal</p>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-2xl p-6 md:p-7 flex flex-col gap-4">
            <div className="flex gap-1">
              {[...Array(5)].map((_, starI) => (
                <i key={starI} className="ri-star-fill text-sm text-primary-500"></i>
              ))}
            </div>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed flex-1">
              &ldquo;Já economizei mais de R$500 usando esta planilha. Os preços são muito melhores que nas lojas locais e a variedade é impressionante.&rdquo;
            </p>
            <div className="flex items-center gap-3 pt-2 border-t border-background-200/70">
              <div className="w-10 h-10 rounded-full overflow-hidden bg-secondary-100 flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Young%20Brazilian%20man%20with%20confident%20expression%20casual%20olive%20green%20shirt%20soft%20natural%20side%20light%20clean%20warm%20cream%20background%20friendly%20professional%20portrait%20headshot%20photography%20warm%20earthy%20palette&width=80&height=80&seq=avatar-pedro-v2&orientation=squarish"
                  alt="Pedro Santos"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-950 leading-tight">Pedro Santos</p>
                <p className="text-xs text-foreground-500 leading-tight">Rio de Janeiro, Brasil</p>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-2xl p-6 md:p-7 flex flex-col gap-4">
            <div className="flex gap-1">
              {[...Array(5)].map((_, starI) => (
                <i key={starI} className="ri-star-fill text-sm text-primary-500"></i>
              ))}
            </div>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed flex-1">
              &ldquo;A seção de bolsas é maravilhosa! Encontrei réplicas de altíssima qualidade que nem parecem ser de planilha. Voltarei a comprar sempre.&rdquo;
            </p>
            <div className="flex items-center gap-3 pt-2 border-t border-background-200/70">
              <div className="w-10 h-10 rounded-full overflow-hidden bg-secondary-100 flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Young%20Portuguese%20woman%20with%20warm%20genuine%20smile%20soft%20sand%20colored%20cardigan%20gentle%20natural%20window%20light%20clean%20cream%20background%20elegant%20relaxed%20portrait%20professional%20headshot%20warm%20neutral%20tones&width=80&height=80&seq=avatar-ana-v2&orientation=squarish"
                  alt="Ana Beatriz"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-950 leading-tight">Ana Beatriz</p>
                <p className="text-xs text-foreground-500 leading-tight">Porto, Portugal</p>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-2xl p-6 md:p-7 flex flex-col gap-4">
            <div className="flex gap-1">
              {[...Array(5)].map((_, starI) => (
                <i key={starI} className="ri-star-fill text-sm text-primary-500"></i>
              ))}
            </div>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed flex-1">
              &ldquo;O que mais gosto é a organização por categorias. Consigo filtrar exatamente o que quero sem perder tempo navegando em sites confusos.&rdquo;
            </p>
            <div className="flex items-center gap-3 pt-2 border-t border-background-200/70">
              <div className="w-10 h-10 rounded-full overflow-hidden bg-secondary-100 flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Young%20Brazilian%20man%20with%20friendly%20warm%20smile%20simple%20cream%20tshirt%20soft%20indoor%20natural%20light%20clean%20warm%20beige%20background%20relaxed%20approachable%20portrait%20professional%20headshot%20warm%20earth%20tone%20palette&width=80&height=80&seq=avatar-rafael-v2&orientation=squarish"
                  alt="Rafael Mendes"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-950 leading-tight">Rafael Mendes</p>
                <p className="text-xs text-foreground-500 leading-tight">Belo Horizonte, Brasil</p>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-2xl p-6 md:p-7 flex flex-col gap-4">
            <div className="flex gap-1">
              {[...Array(5)].map((_, starI) => (
                <i key={starI} className="ri-star-fill text-sm text-primary-500"></i>
              ))}
            </div>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed flex-1">
              &ldquo;Descobri marcas incríveis que nem sabia que existiam. A planilha Hoobuy é essencial para quem quer estilo sem gastar uma fortuna.&rdquo;
            </p>
            <div className="flex items-center gap-3 pt-2 border-t border-background-200/70">
              <div className="w-10 h-10 rounded-full overflow-hidden bg-secondary-100 flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Young%20Brazilian%20woman%20with%20bright%20natural%20smile%20soft%20terracotta%20blouse%20gentle%20diffused%20window%20light%20clean%20cream%20backdrop%20warm%20relaxed%20portrait%20professional%20headshot%20style%20warm%20earthy%20palette&width=80&height=80&seq=avatar-carolina-v2&orientation=squarish"
                  alt="Carolina Alves"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-950 leading-tight">Carolina Alves</p>
                <p className="text-xs text-foreground-500 leading-tight">Brasília, Brasil</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}